import { createPortal } from 'react-dom';
var PORTAL_CONTAINER_ID = 'portal-root';
export function Portal(_ref) {
  var children = _ref.children;
  return createPortal(children, document.getElementById(PORTAL_CONTAINER_ID));
}